<template>
    <div>
        <div v-if="columns">
            <b-container style="margin: 0; padding: 0; max-width: none;">
                <b-row>
                    <b-col :cols="2" v-for="(column, idx_column) in columns" :key="'c' + idx_column">
                        {{column.libelle}}    
                    </b-col>
                    <b-col :cols="2"></b-col>
                </b-row>
                <draggable :group="'array-' + id" :list="data" class="list-group" handle=".handle">
                    <b-row v-for="(item, idx) in data" :key="idx">
                        <b-col :cols="2" v-for="(column, idx_column) in columns" :key="'c' + idx_column">
                            <span v-if="column.type == 'text'">
                                <b-input :list="'list' + id + ' ' + idx + ' '+ idx_column" style="width:200px; display:inline" v-model="data[idx][column.name]"></b-input>
                                <datalist :id="'list' + id + ' ' + idx + ' ' + idx_column">
                                    <option v-for="(option, idx) in columns_datalist" :key="'c' + idx">{{ option }}</option>
                                </datalist>
                            </span>
                            <span v-if="column.type == 'checkbox'"><b-checkbox style="display:inline-block;" v-model="data[idx][column.name]"></b-checkbox></span>
                            <span v-if="column.type == 'list'"><b-select style="width:200px; display:inline" :options="column.options" v-model="data[idx][column.name]"></b-select></span>
                        </b-col>
                        <b-col :cols="2">
                        <b-button variant="link" class="handle"><i class="fas fa-arrows-alt"></i></b-button>
                            <b-button variant="link" @click="del(idx)"><i class="fas fa-trash"></i></b-button>
                        </b-col>
                    </b-row>
                </draggable>
            </b-container>
        </div>
        <div v-else>
            <draggable :group="'array-' + id" :list="data" class="list-group" handle=".handle">
                <div v-for="(item, idx) in data" :key="idx">
                    <b-input v-if="!columns" style="width:300px; display:inline" v-model="data[idx]"></b-input>
                    <b-button variant="link" class="handle"><i class="fas fa-arrows-alt"></i></b-button>
                    <b-button variant="link" @click="del(idx)"><i class="fas fa-trash"></i></b-button>
                </div>
            </draggable>
        </div>

        <b-button variant="link" @click="add()"><i class="fas fa-plus"></i></b-button>

    </div>

</template>

<script>
    import uniqueId from "lodash.uniqueid";
	import draggable from "vuedraggable";

    import store from "../store";

	var clone = require("clone");

    export default {
        name: "array_editor",
        components: {
            draggable
        },
        props: {
            start_data: {
				default: () => [],
            },
            type: {
                default: "text"
            },
            columns: {
                default: () => null
            },
            data_reference: {
                default : () => null
            },
            emit: {
                default: true
            }
        },
        data: function () {
            return {				
                id: uniqueId(""),
                data: [],
                old_data: [],
                columns_datalist: [],
                is_load: false
            };
		},
        watch: 
        {
			data: {
				deep: true,
				handler() {
                    if (!this.is_load && this.emit)
                    {
                        //console.log(this.data)
                        //console.log(this.old_data)
                        this.$emit("update", this.data, clone(this.old_data))
                        this.old_data = clone(this.data);
                    }
				},
			},
        },
		methods: {
            get()
            {
                var old_data = clone(this.old_data)
                this.old_data = clone(this.data);
                return {data: this.data, old_data};
            },
            save()
            {
                return this.data;
            },
            load(data)
            {
                var self = this;
                this.is_load = true;
                this.data = data;
                //console.log(this.data);
                for (var i = 0; i < this.data.length; i++)
                {
                    if (this.columns && typeof this.data[0] != "object")
                    {
                        var obj = {};
                        obj[this.columns[0].name] = this.data[i];
                        this.data[i] = obj;
                    }
                    if (!this.columns && typeof this.data[0] == "object")
                    {
                        this.data[i] = this.data[i][Object.keys(this.data[i])[0]];
                    }
                }
                this.old_data = clone(this.data);
                //console.log(this.data);
                this.$nextTick(() => {
                    self.is_load = false;
                })
            },
            del(idx)
            {
                this.data.splice(idx, 1);
            },
            add()
            {
                var n = "";
                if (this.columns)
                    n = {};
                this.data.push(n);
            }
        },
		mounted: function () {
            var self = this;

            //console.log(this.start_data)

            if (this.start_data)
                this.load(clone(this.start_data));

            if (this.data_reference)
            {
                var data_reference = clone(this.data_reference);
                if (typeof data_reference == "string")
                    data_reference = JSON.parse(data_reference.replaceAll("\\n", "\n"));
                if (Array.isArray(data_reference))
                    data_reference = data_reference[0];
                this.columns_datalist = Object.keys(data_reference);
            }
		},
    }

</script>